import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { REGIONS } from "@/lib/format";
import { SocialIcons } from "@/components/site/SocialIcons";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="site-footer border-t bg-slate-900 text-slate-300">
      <div className="footer-grid mx-auto grid w-full max-w-7xl grid-cols-2 gap-8 px-4 py-10 sm:gap-10 sm:px-6 sm:py-12 md:grid-cols-4 lg:px-8">
        <div className="col-span-2">
          <Link to="/" data-testid="footer-logo" className="inline-flex items-center gap-2">
            <img src="/logo.png" alt="Best Escape Holidays - By N V Hospitalities" className="h-16 w-auto rounded-lg bg-white/95 p-1.5 shadow-lg sm:h-20" />
          </Link>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
            Best Escape Holidays crafts deep, multi-day experiential journeys across the Himalayas, Rajasthan,
            Kerala and the Andaman Islands - handled end-to-end by N V Hospitalities with trusted local partners,
            hand-picked hotels and dedicated on-ground support. Rated 4.8/5 by 478+ happy travellers on Google.
          </p>
          <div className="mt-5 space-y-2 text-sm">
            <a href="tel:+919816672006" data-testid="footer-phone-link" className="flex items-center gap-2"><Phone className="h-4 w-4 shrink-0 text-[hsl(var(--brand-accent))]" /> +91 98166 72006</a>
            <a href="mailto:info@bestescape.in" data-testid="footer-email-link" className="flex items-center gap-2"><Mail className="h-4 w-4 shrink-0 text-[hsl(var(--brand-accent))]" /> info@bestescape.in</a>
            <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[hsl(var(--brand-accent))]" /> Circuit House Rd, near Hotel Anupam, Old Manali, Manali, Himachal Pradesh 175131</div>
          </div>
          <div className="mt-5">
            <p className="mb-2 text-xs uppercase tracking-wide text-slate-500">Follow Us</p>
            <SocialIcons className="flex items-center gap-2 text-slate-300" iconClassName="h-4 w-4" />
          </div>
        </div>
        <div>
          <h4 className="font-display text-sm font-semibold text-white">Destinations</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {REGIONS.map((r) => (
              <li key={r}>
                <Link to={`/packages?region=${r}`} data-testid={`footer-region-link-${r.toLowerCase()}`} className="hover:text-white">
                  {r} Packages
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display text-sm font-semibold text-white">Company</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/packages" data-testid="footer-all-packages-link" className="hover:text-white">All Packages</Link></li>
            <li><Link to="/privacy-policy" data-testid="footer-privacy-link" className="inline-flex min-h-11 items-center hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions" data-testid="footer-terms-link" className="inline-flex min-h-11 items-center hover:text-white">Terms & Conditions</Link></li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">Admin Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-slate-500">
        <p>&copy; {new Date().getFullYear()} Best Escape Holidays &mdash; By N V Hospitalities. All rights reserved.</p>
        <p className="mt-1">
          Made by{" "}
          <a
            href="https://www.cybercubes.in"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cybercubes-credit-link"
            className="font-medium text-slate-400 hover:text-white"
          >
            CyberCubes Marketplaces
          </a>
        </p>
      </div>
    </footer>
  );
}
